<script>
import LogoComponent from '@/V2/Logo';
export default {
  components: { LogoComponent },
  props: {},
};
</script>

<template>
  <div class="left-side-logo d-flex flex-column">
    <logo-component class="logo-component" height="44px" />
    <img class="auth-bg" src="../../img/auth_bg.svg" />
  </div>
</template>

<style lang="scss" scoped>
.left-side-logo {
  width: 100%;
  height: 100%;
  background: $brand-purple;
  padding-top: 172px;
  position: relative;
  overflow: hidden;

  .logo-component {
    z-index: 1;
    :deep(path) {
      fill: #fff;
    }
  }

  .auth-bg {
    position: absolute;
    bottom: -20%;
    right: 0px;
    width: 100%;
    height: 100%;
  }
}
</style>
